// Shared types and query key for the Shipping providers hub (split out so the
// component files only export components).

export type ProviderId =
  | 'avocore'
  | 'byelabel'
  | 'shipdad'
  | 'uniuni'
  | 'stamps'
  | 'shipstation'
  | 'usps'

export type ProviderDef = {
  id: ProviderId
  label: string
  role: string
  fields: string[]
  hasBalance: boolean
}

export type CarrierCredential = {
  id: string
  carrier_id: ProviderId
  account_identifier: string
  has_credentials: boolean
  credential_fields: string[]
  active: boolean
  last_validated_at: string | null
}

export type ConnectionTest = { ok: boolean; message: string; cheapest_usd: number | null }

export const CREDENTIALS_QUERY_KEY = ['carrier-credentials'] as const
